import "./_accordion.scss";

export default function Accordion() {
    const $accordionComponent = document.querySelectorAll('.accordion');
    if ($accordionComponent.length > 0) {
        $accordionComponent.forEach(($accordion, index) => {
            const $accordions = $accordion.querySelectorAll('.accordion-wrapper')
            $accordion.setAttribute('id', `accordion-${index}`);
            const accordionId = $accordion.getAttribute('id');
            const $nodeCalendar = document.querySelector('.node.calendario') as HTMLElement;

            let counter = 0;
            const $input = Array.from($accordion.querySelectorAll('input'));
            const $label = Array.from($accordion.querySelectorAll('label'));

            $input.forEach(($el, index) => {
                const uniqueId = `accordion-${counter++}-${accordionId}`;
                $el.setAttribute('id', uniqueId);
                $label[index].setAttribute('for', uniqueId);

                if($nodeCalendar) {
                    $el.checked = true;
                    ($el.closest('div.accordion-wrapper') as HTMLDivElement).classList.add('active');
                    const $headerActive = $accordion.querySelectorAll('.accordion-wrapper.active .accordion-header');

                    $headerActive.forEach(($el) => {
                        $el.setAttribute('aria-label', 'riduci dettagli');
                    })
                }

                $el.addEventListener('change', (e) => {
                    const target = e.target as any;
                    if (target.checked === true) {
                        (target.closest('div.accordion-wrapper') as HTMLDivElement).classList.add('active');
                        const $headerActive = $accordion.querySelectorAll('.accordion-wrapper.active .accordion-header');

                        $headerActive.forEach(($el) => {
                            $el.setAttribute('aria-label', 'riduci dettagli');
                        })
                    } else if (target.checked === false) {
                        (target.closest('div.accordion-wrapper') as HTMLDivElement).classList.remove('active');
                        const $headerActive = $accordion.querySelectorAll('.accordion-wrapper .accordion-header');

                        $headerActive.forEach(($el) => {
                            $el.setAttribute('aria-label', 'espandi dettagli');
                        })
                    }
                })
            })

            $accordions.forEach(($item) => {
                const $accordionHeader = $item.querySelector('.accordion-header') as HTMLElement;
                $accordionHeader.addEventListener('keypress', function (e) {
                    const $inputAccordion = $item.querySelector('input') as HTMLInputElement;
                    if ($inputAccordion.getAttribute('checked') === null) {
                        if (e.code === 'Enter') {
                            $inputAccordion.setAttribute('checked', 'checked');
                            $item.classList.add('active');
                            $accordionHeader.setAttribute('aria-label', 'riduci dettagli');
                        }
                    } else if ($inputAccordion.getAttribute('checked') === 'checked') {
                        if (e.code === 'Enter') {
                            $inputAccordion.removeAttribute('checked');
                            $item.classList.remove('active');
                            $accordionHeader.setAttribute('aria-label', 'espandi dettagli');
                        }
                    }
                })
            })
        })
    }
}